<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  export let campaignName;
</script>

<Icon class="far fa-clock pending-dot" size="xs" placement="left">
  <span slot="tooltip">Scheduled for '{campaignName}'</span>
</Icon>
